import React, { Component } from 'react';
import PropTypes from 'prop-types';

import AlertMessage from '../../../../components/AlertMessage';

import './styles.css';

class ImageUpload extends Component {
  constructor(props) {
    super(props);

    const { imageBase64 } = props;
    this.state = {
      imagePreviewUrl: imageBase64 ? `data:image;base64,${imageBase64}` : '',
      invalidFileExtension: false,
    };
  }

    _handleImageChange = (e) => {
      e.preventDefault();

      const reader = new FileReader();
      const file = e.target.files[0];
      const { onChange } = this.props;

      if (file && !file.name.match(/.(jpg|jpeg|png|gif)$/i)) {
        this.setState({ imagePreviewUrl: '', invalidFileExtension: true });
        return;
      }
      this.setState({ invalidFileExtension: false });


      reader.onloadend = () => {
        const imagePreviewUrl = reader.result;
        this.setState({ imagePreviewUrl });
        onChange(file);
      };

      if (file) reader.readAsDataURL(file);
    }

    _hasImagePreviewUrl = () => this.state.imagePreviewUrl !== ''

    _getBackgroundImageStyle = () =>
      (this._hasImagePreviewUrl() ? { backgroundImage: `url(${this.state.imagePreviewUrl})` } : {})


    render() {
      const { label } = this.props;
      const { invalidFileExtension } = this.state;

      return (
        <div
          className="ImageUpload"
        >
          <div className="ImageUpload__label">{label}</div>
          <div
            className={`ImageUpload__logo-container${
                        this._hasImagePreviewUrl() ? ' ImageUpload__logo-container--has-logo' : ''}`}
            style={this._getBackgroundImageStyle()}
            onClick={() => this.fileUpload.click()}
          >
            { this._hasImagePreviewUrl() ? '' : 'CLIQUE PARA INCLUIR' }
          </div>
          {
                    invalidFileExtension &&
                    <AlertMessage
                      error
                      box
                      className="ImageUpload__error"
                      message="Extensão de arquivo não suportada."
                    />
                }
          <input
            ref={el => this.fileUpload = el}
            className="ImageUpload__input"
            type="file"
            onChange={this._handleImageChange}
          />
        </div>
      );
    }
}

ImageUpload.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default ImageUpload;
